import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
if (import.meta.env.MODE === "production" && sentryDsn) {
  Sentry.init({ dsn: sentryDsn });
}

const fallback = (
  <div style={{ padding: "2rem", textAlign: "center" }}>
    <h2>Something went wrong</h2>
    <p>An unexpected error occurred. Please refresh the page or contact support if the problem persists.</p>
    <button onClick={() => window.location.reload()} style={{ marginTop: "1rem", padding: "0.5rem 1.5rem", cursor: "pointer" }}>
      Refresh page
    </button>
  </div>
);

createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary fallback={fallback}>
    <App />
  </Sentry.ErrorBoundary>
);
